import { ReactNode } from "react";
import { useAuth } from "../../context/AuthContext";

interface AuthWrapperProps {
  children: ReactNode;
  fallback?: ReactNode;
}

/**
 * A wrapper component that ensures the auth context is available
 * This helps prevent "useAuth must be used within an AuthProvider" errors
 */
const AuthWrapper = ({ children, fallback = null }: AuthWrapperProps) => {
  try {
    // Check if we can access the auth context
    useAuth();
    return <>{children}</>;
  } catch (error) {
    // If auth context is not available, return the fallback
    console.warn("Auth context not available in AuthWrapper:", error);
    return <>{fallback}</>;
  }
};

export default AuthWrapper;
